import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import SearchField from "../../Form/SearchField";
import { OpportunityAssigneeSearch } from "./OpportunityAssigneeSearch";
export const getEditAssigneeRequest = (formState) => {
    return {
        assignee: formState.assignee,
    };
};
const EditAssigneeForm = ({ pipelineId }) => {
    return (_jsx(SearchField, { name: "assignee", label: "Assignee", required: true, as: (provided) => (_jsx(OpportunityAssigneeSearch, Object.assign({}, provided, { pipelineId: pipelineId, sort: "PERSONLASTNAME", order: "asc", noOptionsMessage: () => {
                return "No Options";
            } }))) }));
};
export default EditAssigneeForm;
